/* ============================================================= */
/*  ll-model-collateral-edit.component.ts                        */
/* ============================================================= */

import {
  Component,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  ElementRef,
  OnDestroy,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { LlModelsService } from '../ll-models.service';
/*import { LlRolesService } from '../ll-roles.service';*/
import { LlUtilityService } from '../ll-utility.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxPopoverComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxpopover";

interface lenderClassesRecord {
  CLIENTFINANCIALCLASSID: number;
  FINANCIALCLASSNAME: string;
}

interface payerRecord {
  PAYERID: number;
  CLIENTFINANCIALCLASSID: number;
  FINANCIALCLASSNAME: string;
  LENDER_FINANCIALCLASSNAME: string;
  LENDER_CLIENTFINANCIALCLASSID: number;
  SELECTED: boolean;
  ROWIDEX:0,
}

@Component({
  selector: 'll-model-classes-lender-edit',
  templateUrl: './ll-model-classes-lender-edit.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlModelClassesLenderEditComponent {

  @ViewChild('mainDiv_ll_model_classes_lender_edit') mainDiv!: ElementRef<HTMLElement>;
  @ViewChild('datagrid_lender_classes') class_datagrid!: jqxGridComponent;
  @ViewChild('datagrid_payers') payer_datagrid!: jqxGridComponent;

  /* ----------------------------------------------------------- */
  bundle = {
    class_gridX: 0,
    class_gridY: 50,
    class_gridW: 0,
    class_gridH: 200,
    payer_gridX: 0,
    payer_gridY: 0,
    payer_gridW: 0,
    payer_gridH: 0,

    lenderClasses: [] as lenderClassesRecord[],
    payers: [] as payerRecord[],
    class_columns: [] as any[],
    payer_columns: [] as any[],
    selectedPayers: [] as any[],
    showObj: false,
    saved: true,
    showGrids: false,
    headerLable: "Collateral Settings",
    fileLabel: '',
    headerDescription: '',
    userMessage: '',
    activeClassId: 0,
    activeClassName:'CLASS SELECTION ABOVE REQUIRED',
  };

  openDropdownIndex = -1;
  private gridInitialized = false;

  constructor(
    private llModelsService: LlModelsService,
    //private LlRolesService: LlRolesService,
    private LlUtilityService: LlUtilityService,
    private cd: ChangeDetectorRef
  ) { }

  /* ----------------------------------------------------------- */
  ngAfterViewInit(): void {
    this.setVars();
  }

  ngAfterViewChecked(): void {
    if (this.bundle.showGrids && this.class_datagrid && this.payer_datagrid && !this.gridInitialized) {
      this.gridInitialized = true;
      setTimeout(() => this.paintClass_Grid(), 0);
    }
  }

  ngOnDestroy(): void {
    this.gridInitialized = false;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.calculateGridSize();
    if (this.class_datagrid) {
      this.class_datagrid.width(this.bundle.class_gridW);
      this.class_datagrid.height(this.bundle.class_gridH);
    }
    if (this.payer_datagrid) {
      this.payer_datagrid.width(this.bundle.payer_gridW);
      this.payer_datagrid.height(this.bundle.payer_gridH);
    }
  }

  /* ============================================================= */
  private setVars(): void {

    this.bundle.fileLabel = this.bundle.headerLable;
    this.bundle.headerDescription = "Click on grid-cell to change its value.  Hit 'Enter' key to save change."

    setTimeout(() => {
      this.calculateGridSize();
      /*this.initializeChoices();*/
      this.getData();
    }, 0);
  }

  private calculateGridSize(): void {
    const container = this.mainDiv.nativeElement.parentElement?.parentElement;
    if (container) {
      const margin = 30;
      this.bundle.class_gridW = container.clientWidth - margin;
      this.bundle.class_gridX = (container.clientWidth - this.bundle.class_gridW) / 2;
      this.bundle.payer_gridY = this.bundle.class_gridY + this.bundle.class_gridH + 40
      this.bundle.payer_gridW = this.bundle.class_gridW;
      this.bundle.payer_gridH = container.clientHeight - this.bundle.payer_gridY - 40;
      this.bundle.payer_gridX = this.bundle.class_gridX;
    }
  }

  //private initializeChoices(): void {
  //  this.bundle.yesNoChoices = [{ choice: 'Yes' }, { choice: 'No' }];
  //  this.bundle.periodChoices = [
  //    { choice: '30' }, { choice: '60' }, { choice: '90' },
  //    { choice: '120' }, { choice: '150' }, { choice: '180' }
  //  ];
  //}

  /* ============================================================= */
  private getData(): void {
    const callback02 = (payers: any[]) => {
      this.bundle.payers = payers;
      this.bundle.showGrids = true;

      // Safe way to trigger UI updates + grid painting without setTimeout
      this.cd.detectChanges();

      // These now run after change detection, so DOM is ready
      this.paintClass_Grid();
      this.paintPayer_Grid();
    };

    const callback01 = (lenderClasses: any[]) => {
      this.bundle.lenderClasses = lenderClasses;

      // Chain the next call using the original callback style
      this.llModelsService.NG_LL_model_AR_payersWithLenderClass_get(callback02);
    };

    // Start the chain
    this.llModelsService.NG_LL_model_AR_payerLenderClasses_get(callback01);
  }

  /* ============================================================= */
  private paintClass_Grid(): void {
    if (!this.class_datagrid) {
      console.warn('jqxGrid not ready – will retry in 100 ms');
      setTimeout(() => this.paintClass_Grid(), 100);
      return;
    }

    this.bundle.class_columns = [];
    this.bundle.class_columns.push({ text: 'Class', datafield: 'FINANCIALCLASSNAME', width: this.bundle.class_gridW, editable: false });
    const datafields = this.bundle.class_columns.map(col => ({
      name: col.datafield,
      type: "string"
    }));

    setTimeout(() => {
      const source = { localdata: this.bundle.lenderClasses, datatype: 'array', datafields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.class_datagrid.source(dataAdapter);
      this.class_datagrid.columns(this.bundle.class_columns);
      this.class_datagrid.width(this.bundle.class_gridW);
      this.class_datagrid.height(this.bundle.class_gridH);
      this.class_datagrid.updatebounddata();
    }, 0);

    setTimeout(() => {
      ///this.bundle.showGrids = true;
      this.bundle.showObj = true;
    }, 0);
  }


  private paintPayer_Grid(): void {
    //if (!this.payer_datagrid) {
    //  console.warn('jqxGrid not ready – will retry in 100 ms');
    //  setTimeout(() => this.paintClass_Grid(), 100);
    //  return;
    //}

    let W01 = 70
    let W03 = 150
    let W04 = 150
    let W02 = this.bundle.payer_gridW - W01 - W03 - W04 - 20;

    this.bundle.payer_columns = [];
    this.bundle.payer_columns.push({ text: 'Select', datafield: 'SELECTED', columntype: 'checkbox', width: W01, editable: true, align: 'left' });
    this.bundle.payer_columns.push({ text: 'Name', datafield: 'PAYERNAME', width: W02, editable: false });
    this.bundle.payer_columns.push({ text: 'Client Name', datafield: 'FINANCIALCLASSNAME', width: W03, editable: false });
    this.bundle.payer_columns.push({ text: 'New Class Name', datafield: 'LENDER_FINANCIALCLASSNAME', width: W04, editable: false });

    const datafields = this.bundle.payer_columns.map(col => ({
      name: col.datafield,
      type: "string",
    }));

    setTimeout(() => {
      const source = { localdata: this.bundle.payers, datatype: 'array', datafields };
      const dataAdapter = new jqx.dataAdapter(source);

      this.payer_datagrid.source(dataAdapter);
      this.payer_datagrid.columns(this.bundle.payer_columns);
      this.payer_datagrid.width(this.bundle.payer_gridW);
      this.payer_datagrid.height(this.bundle.payer_gridH);
      this.payer_datagrid.updatebounddata();
    }, 0);

    setTimeout(() => {
      ///this.bundle.showGrids = true;
      this.bundle.showObj = true;
    }, 0);
  }

  selectLenderClass(event: any): void {

    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;

    this.bundle.activeClassId = this.bundle.lenderClasses[rowIndex].CLIENTFINANCIALCLASSID;
    this.bundle.activeClassName = this.bundle.lenderClasses[rowIndex].FINANCIALCLASSNAME;

    //console.log(this.bundle.activeClassId)
    //console.log(this.bundle.activeClassName)
  }

  selectAll() {

    var rows = this.payer_datagrid.getdisplayrows();

    for (let k = 0; k < rows.length; k++) {
      this.bundle.payers[rows[k].uid].SELECTED = true;
      this.bundle.payers[rows[k].uid].ROWIDEX = rows[k].uid;
      
      this.bundle.selectedPayers[this.bundle.selectedPayers.length] = this.bundle.payers[rows[k].uid];
    }

    this.payer_datagrid.updatebounddata('cells');
  }

  selectPayer(event: any): void {
    let rowIndex = event.args.rowindex;
    let dataField = event.args.datafield;
    let newValue = event.args.newvalue;
   
    if (newValue == true) {
      this.bundle.payers[rowIndex].ROWIDEX = rowIndex;
      this.bundle.selectedPayers[this.bundle.selectedPayers.length] = this.bundle.payers[rowIndex];

    } else {
      this.bundle.selectedPayers = this.bundle.selectedPayers.filter(payer =>
        payer.PAYERID !== this.bundle.payers[rowIndex].PAYERID
      );
    }

    ///console.log(this.bundle.selectedPayers)
    
  }


  save(): void {
    this.bundle.saved = true;    

    for (let k = 0; k < this.bundle.selectedPayers.length; k++) {
      this.bundle.selectedPayers[k].LENDER_CLIENTFINANCIALCLASSID = this.bundle.activeClassId;
      this.bundle.selectedPayers[k].LENDER_FINANCIALCLASSNAME = this.bundle.activeClassName;
    }

    //console.log(this.bundle.selectedPayers)

    const callback01 = () => {

      for (let k = 0; k < this.bundle.selectedPayers.length; k++) {
        this.bundle.payers[this.bundle.selectedPayers[k].ROWIDEX].LENDER_CLIENTFINANCIALCLASSID = this.bundle.activeClassId;
        this.bundle.payers[this.bundle.selectedPayers[k].ROWIDEX].LENDER_FINANCIALCLASSNAME = this.bundle.activeClassName;
      }

      this.bundle.selectedPayers.splice(0);
      this.payer_datagrid.updatebounddata('cells');
      this.cd.detectChanges(); // Ensure the "Not Saved!" message updates
    };

    this.llModelsService.NG_LL_model_AR_payersWithLenderClass_edit(callback01,this.bundle.selectedPayers);
  }



  exportOnClick() {

    let label = this.bundle.fileLabel;

    //console.log(label)

    for (let k = 0; k < this.bundle.payer_columns.length; k++) {

      this.bundle.payer_columns[k].STUDYCOLUMNQUESTIONIDALPHA = this.bundle.payer_columns[k].datafield;
      this.bundle.payer_columns[k].STUDYCOLUMNLABEL = this.bundle.payer_columns[k].text
      this.bundle.payer_columns[k].SYSTEMORGANIZATIONFIELDCODE = this.bundle.payer_columns[k].datafield
    }

    var rows = this.payer_datagrid.getdisplayrows();

    this.LlUtilityService.saveCSV(rows, this.bundle.payer_columns, label)

  };

}
